'use es6';

import { withTheme } from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { Children, Component } from 'react';
import { fromJS } from 'immutable';
import IndexHeaderButtonsSlot from 'SalesContentIndexUI/slots/IndexHeaderButtonsSlot';
import IndexAlertsSlot from 'SalesContentIndexUI/slots/IndexAlertsSlot';
import IndexBodySlot from 'SalesContentIndexUI/slots/IndexBodySlot';
import IndexHeaderButtons from 'SalesContentIndexUI/components/header/IndexHeaderButtons';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { Header } from 'foundations-components/transitional/components/Header';
import { assertPropsDefined } from '../utils/PropValidationUtils';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
class IndexPageWithoutTheme extends Component {
  constructor(...args) {
    super(...args);
    this.getChildMap = () => {
      let childMap = fromJS({
        headerButtons: null,
        alerts: null,
        indexBody: null
      });
      Children.forEach(this.props.children, child => {
        const childType = child ? child.type : '';
        switch (childType) {
          case IndexHeaderButtonsSlot:
            childMap = childMap.set('headerButtons', child);
            break;
          case IndexHeaderButtons:
            childMap = childMap.set('headerButtons', child);
            break;
          case IndexAlertsSlot:
            childMap = childMap.set('alerts', child);
            break;
          case IndexBodySlot:
            childMap = childMap.set('indexBody', child);
            break;
          default:
            break;
        }
      });
      return childMap;
    };
    this.renderBody = () => {
      const childMap = this.getChildMap();
      return /*#__PURE__*/_jsxs("div", {
        children: [childMap.get('alerts'), childMap.get('indexBody')]
      });
    };
    this.renderHeader = () => {
      const {
        tabs,
        title
      } = this.props;
      const childMap = this.getChildMap();
      return /*#__PURE__*/_jsx(Header, {
        tabs: tabs,
        title: title,
        children: childMap.get('headerButtons')
      });
    };
  }
  render() {
    assertPropsDefined({
      title: this.props.title
    });
    const {
      backgroundColor,
      theme,
      pageLayout,
      pageMaxWidth
    } = this.props;
    return /*#__PURE__*/_jsx(ListingPage, {
      headerComponent: this.renderHeader(),
      mainSectionBackgroundColor: backgroundColor || theme.color['fill-surface-default'],
      pageLayout: pageLayout,
      pageMaxWidth: pageMaxWidth,
      children: this.renderBody()
    });
  }
}
IndexPageWithoutTheme.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.any,
  tabs: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  pageLayout: PropTypes.string
};
const IndexPage = withTheme(IndexPageWithoutTheme);
export default IndexPage;